import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getMetadata } from '../seo/publicSite';

function setMeta(attribute, key, value) {
  const matches = document.head.querySelectorAll(`meta[${attribute}="${key}"]`);
  const element = matches[0] || document.createElement('meta');
  matches.forEach((duplicate, index) => { if (index > 0) duplicate.remove(); });
  element.setAttribute(attribute, key);
  element.setAttribute('content', value);
  element.dataset.oscopSeo = 'true';
  if (!element.parentNode) document.head.appendChild(element);
}

export function updateDocumentMetadata(pathname) {
  const metadata = getMetadata(pathname);
  document.documentElement.lang = 'fr';
  document.title = metadata.title;
  setMeta('name', 'description', metadata.description);
  setMeta('name', 'robots', metadata.robots);
  setMeta('property', 'og:title', metadata.title);
  setMeta('property', 'og:description', metadata.description);
  setMeta('property', 'og:type', metadata.page.article ? 'article' : 'website');
  setMeta('property', 'og:locale', 'fr_FR');
  setMeta('property', 'og:site_name', "O'SCOP");
  setMeta('property', 'og:image', metadata.image);
  setMeta('name', 'twitter:card', 'summary');
  setMeta('name', 'twitter:title', metadata.title);
  setMeta('name', 'twitter:description', metadata.description);
  setMeta('name', 'twitter:image', metadata.image);

  document.querySelectorAll('link[rel="canonical"]').forEach(node => node.remove());
  document.querySelectorAll('meta[property="og:url"]').forEach(node => node.remove());
  if (metadata.canonical) {
    const link = document.createElement('link');
    link.rel = 'canonical';
    link.href = metadata.canonical;
    link.dataset.oscopSeo = 'true';
    document.head.appendChild(link);
    setMeta('property', 'og:url', metadata.canonical);
  }

  document.getElementById('oscop-structured-data')?.remove();
  if (metadata.structuredData) {
    const script = document.createElement('script');
    script.id = 'oscop-structured-data';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(metadata.structuredData);
    document.head.appendChild(script);
  }
}

export default function PublicPageMetadata() {
  const { pathname } = useLocation();
  useEffect(() => { updateDocumentMetadata(pathname); }, [pathname]);
  return null;
}
